import request from '@/utils/request';
import {
  setStore,
  getStore,
} from '@/utils/store'
const projectName = '/api/blade-platform';
// const projectName = '';

const sensitiveWord = {
    state: {
        sensitiveWordComponentName: getStore({
            name: 'sensitiveWordComponentName'
        }) || 'basicPage',
    },
    mutations: {
        SET_sensitiveWordComponentName: (state, sensitiveWordComponentName) => {
            state.sensitiveWordComponentName = sensitiveWordComponentName
            setStore({
                name: 'sensitiveWordComponentName',
                content: state.sensitiveWordComponentName,
                type: 'session'
            })
        }
    },
    actions: {
        // 获取敏感词管理检索条件
        getActionTypeList(actions) {
            return request({
                url: `${projectName}/platformalumniword/getActionTypeList`,
                method: 'get',
            })
        },
        getDealConfig(actions) {
            return request({
                url: `${projectName}/platformalumnimechanismconfig/list`,
                method: 'get',
            })
        },
        getAlumniWordList(actions, data) {
            return request({
                url: `${projectName}/platformalumniword/getAlumniWordList`,
                method: 'post',
                data
            })
        },
        saveShieldWord(actions, data) {
            return request({
                url: `${projectName}/platformalumniword/save`,
                method: 'post',
                data
            })
        },
        updateShieldWord(actions, data) {
            return request({
                url: `${projectName}/platformalumniword/update`,
                method: 'post',
                data
            })
        },
        removeShieldWord(actions, data) {
            return request({
                url: `${projectName}/platformalumniword/remove`,
                method: 'post',
                data
            })
        },
    }
}
export default sensitiveWord
